import React from "react";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "../shared/context/ThemeContext.jsx";
import { loadAppConfig, getConfigDefaults } from "../api/configLoader.js";
import { applyGlobalPrivacyControlDefaultIfNeeded } from "../shared/cookieConsent/cookieConsentStorage.js";
import { getApiBase } from "../shared/utils/urlHelpers.js";
import { helpSiteFormSlugFromPath } from "@shared/helpSiteForms.js";
import "./siteFormHost.css";

document.documentElement.setAttribute("data-nm-resolved", "light");
document.documentElement.style.colorScheme = "light";

const CONFIG_WAIT_MS = 6000;

(async function siteFormBootstrap() {
  const container = document.getElementById("site-form-root");
  if (!container) return;
  container.setAttribute("data-theme", "light");

  const slug = helpSiteFormSlugFromPath(window.location.pathname);
  if (!slug) {
    window.location.replace("/");
    return;
  }

  const configPromise = loadAppConfig().catch((e) => {
    console.error("Site form config load failed:", e);
    return null;
  });

  try {
    const timeoutPromise = new Promise((resolve) => setTimeout(() => resolve("timeout"), CONFIG_WAIT_MS));
    const raced = await Promise.race([configPromise, timeoutPromise]);
    if (raced === "timeout") {
      await Promise.race([
        configPromise,
        new Promise((resolve) => setTimeout(resolve, 1500))
      ]);
    }
    if (!window.nitromuleReactData) {
      window.nitromuleReactData = {
        ...getConfigDefaults(),
        apiUrl: `${getApiBase()}${getApiBase().endsWith("/api") ? "" : "/api"}`
      };
    }
  } catch (e) {
    console.error("Site form config load failed:", e);
    window.nitromuleReactData = window.nitromuleReactData || {
      ...getConfigDefaults(),
      apiUrl: `${window.location.origin}/api`
    };
  }

  applyGlobalPrivacyControlDefaultIfNeeded();

  try {
    const { default: SiteFormPage } = await import("../app/SiteFormPage.js");
    const { default: AppErrorBoundary } = await import("../app/AppErrorBoundary.js");
    const root = createRoot(container);
    root.render(
      React.createElement(
        ThemeProvider,
        { forceResolvedTheme: "light" },
        React.createElement(
          AppErrorBoundary,
          null,
          React.createElement(SiteFormPage, { slug })
        )
      )
    );
  } catch (e) {
    console.error("[nm] site form mount failed:", e?.message || e);
    container.innerHTML =
      '<p style="padding:24px;color:#E9042B">Could not load this form. Please try again.</p>';
  }
})();
